<template>
  <div style="margin-top:20px;width: 100%;"
       class="flexCenter">
    <div class="highlights_item"
         :style="{'flex':index == activeIndex?'2':'1','backgroundImage':'url(' + $imgUrl+ item.url + ')' ,'backgroundPosition':'50%','backgroundSize':index != activeIndex?'cover':'100% 100%' ,'backgroundRepeat': 'no-repeat'}"
         @mouseenter="mouseover(index)"
         v-for="(item,index) in list"
         :key="index">
      <div v-if="index!= activeIndex"
           class="hide">
        {{item.text}}
      </div>
      <div class="show"
           v-else>
        <div style="font-weight:bold"
             class="font24">{{item.text}}</div>
        <div style="color:#eee;margin-top: 10px;line-height:24px;height: 200px;"
             class="font16">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      activeIndex: 0,
      list: [
        { url: 'home/FW_ONE.png', text: '线上教育', content: '钧策咨询历时数载，独立研发“线上商学院——零售人的加油站”，整合数十位各领域专家老师，将行业经验成体系沉淀至平台，精心打磨研发出400余期音视频、表单工具等系列课程，并持续不断更新，帮助个人提升自我技能与认知，帮助企业打造专属的线上商学院平台！' },
        { url: 'home/FW_two.png', text: '线下培训', content: '每年在全国开设近80余期线下课程，类型涵盖行业热点课、标杆游学课、卖场实操课、岗位集训营、资源对接课，中国零售总裁峰会。系统解决企业经营、管理、财税、战略中存在的问题，每年培训上万名零售从业者，会员企业超1000余家！' },
        { url: 'home/FW_FRE.png', text: '咨询顾问', content: '通过对企业1对1深度调研与诊断，围绕战略、经营、管理、财税四大板块分阶段，通过线上会议+线下入驻企业的方式，定制方案落地“扶上马送一程”，帮助企业实现业绩提升、管理提效！30余位专家老师来自国内外标杆企业，有丰富的实操与成功经验，每年帮助上百家企业实现业绩突破，战略落地！说我所做，做我所说！' },
        { url: 'home/e687171d4ff036adb4b8df6a31fa12e.png', text: '零售圈子', content: '零售私董会由钧策咨询创始人万辉先生成立，旨在建立一个有理念、有想法、能同频、对商业有认知零售企业家圈子，在这里能够解决企业现有问题，提高解决问题的能力，在这里会进入高能量、高质量人脉圈子，找到同频的优秀企业家，在这里成员之间资源共享，信息共享，知识与智慧共享，在这里能看项目、找项目、投项目，教投资、学投资、做投资！私董会诚邀您的加入！' },
        { url: 'home/ee110555e2c3ea734a9e2125eac5947.png', text: '数字工具', content: '通过系统工具+运营体系帮助企业成功跨越时代周期，紧跟数字化与智能化趋势，在降本增效的同时，打造一套可持续发展的企业运营体系，对内从员工管理、商品管理、门店管理实现效率提升；对外从会员管理、营销管理、配送管理实现效益提升！' }
      ]
    }
  },
  methods: {
    mouseover (e) {
      console.log(e)
      this.activeIndex = e
    },
    mouseout (e) {
      console.log('mouseout' + e)
    }
  }
}
</script>
<style lang="less" scoped>
// .active {
//   flex: 2;
//   margin-right: 20px;
//   border-radius: 20px;
//   background-color: #fff;
//   height: 400px;
// }
.highlights_item {
  // flex: 1;
  margin-right: 20px;
  border-radius: 10px;
  // padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  height: 376px;
  transition: all 0.3s ease-in-out;
  position: relative;
  .hide {
    width: 100%;
    height: 100%;
    padding: 50px;
    border-radius: 10px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 30px;
  }
  .show {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    padding: 30px 40px;
    box-sizing: border-box;
    color: #fff;
    // display: flex;
    // align-items: flex-end;
    // justify-content: flex-start;
  }
}
.highlights_item:nth-child(5) {
  margin-right: 0;
}
</style>